exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discuss-notification[data-v-a98a62d4]{float:left;position:relative;border-radius:.4em;display:inline-table;min-width:10px;padding:0 6px;line-height:10px;font-size:10px;color:#fff}.discuss-notification[data-v-a98a62d4]:after{content:\"\";position:absolute;bottom:0;left:50%;width:0;height:0;border:5px solid transparent;border-bottom:0;border-left:0;margin-left:-2.5px;margin-bottom:-5px}.discuss-notification-default[data-v-a98a62d4]{background:#a9a9a9}.discuss-notification-default[data-v-a98a62d4]:after{border-top-color:#a9a9a9}.discuss-notification-warning[data-v-a98a62d4]{background:#f58646}.discuss-notification-warning[data-v-a98a62d4]:after{border-top-color:#f58646}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a98a62d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/discuss/discussion-notification-icon.vue
// module id = 1159
// module chunks = 0